import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(value) {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value)
}

export function formatDate(dateString) {
  if (!dateString) return '-'
  // Parse YYYY-MM-DD as LOCAL date to avoid UTC→local day shift
  // (ISO dates without time are interpreted as UTC midnight by the Date constructor)
  const dateOnly = String(dateString).slice(0, 10)
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateOnly)
  if (match) {
    const [, y, m, d] = match
    return `${d}/${m}/${y}`
  }
  const date = new Date(dateString)
  return new Intl.DateTimeFormat('pt-BR').format(date)
}

/**
 * Returns today's date in the user's LOCAL timezone as YYYY-MM-DD.
 * Prevents the "off-by-one day" bug that `new Date().toISOString().slice(0,10)`
 * introduces when the local time crosses midnight in UTC (e.g. Brazil after 21h).
 */
export function todayLocalISO() {
  const now = new Date()
  const y = now.getFullYear()
  const m = String(now.getMonth() + 1).padStart(2, '0')
  const d = String(now.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

export function formatDateTime(dateString) {
  if (!dateString) return '-'
  const date = new Date(dateString)
  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(date)
}

export function getStatusColor(status) {
  const colors = {
    aberto: 'bg-slate-100 text-slate-800 border-slate-200',
    pronto_pagamento: 'bg-amber-100 text-amber-800 border-amber-200',
    programado: 'bg-purple-100 text-purple-800 border-purple-200',
    aprovado: 'bg-blue-100 text-blue-800 border-blue-200',
    pago: 'bg-emerald-100 text-emerald-800 border-emerald-200',
    em_andamento: 'bg-blue-100 text-blue-800 border-blue-200',
    concluido: 'bg-emerald-100 text-emerald-800 border-emerald-200',
    vencido: 'bg-rose-100 text-rose-800 border-rose-200'
  }
  return colors[status] || 'bg-slate-100 text-slate-800 border-slate-200'
}

export function getStatusLabel(status) {
  const labels = {
    aberto: 'Aberto',
    pronto_pagamento: 'Pronto p/ Pagamento',
    programado: 'Programado',
    aprovado: 'Aprovado',
    pago: 'Pago',
    em_andamento: 'Em Andamento',
    concluido: 'Concluído',
    vencido: 'Vencido'
  }
  return labels[status] || status
}
